export default __webpack_public_path__ + "static/media/starofthesea.ce47482c.jpg";